app.factory('statusReasonService', ['$q', 'baseService', 'objectHelper', 'config', 
    function($q, baseService, objectHelper, config) {

	    function StatusReasonService() {
	
	        this.getList = function(objectType, statusReasonType) {

	            var statusReasonRequestWrapper = {
	            	objectType: objectType,
	            	statusReasonType: statusReasonType
	            };
	
	            return baseService.post(config.API_URL + '/statusReason/getList', statusReasonRequestWrapper).then(
	                function(successResponse) {
	                    var data = objectHelper.translateArray(successResponse, StatusReasonVO);
	                    return data;
	                },
	                function(errorResponse) {
	                    return $q.reject(errorResponse);
	                }
	            );
	        };
	
	    }
	
	    return new StatusReasonService();
	}
]);
